import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './store/auth';
import LoginPage from './pages/LoginPage';
import AppLayout from './layouts/AppLayout';
import InboxPage from './pages/InboxPage';
import TicketDetailPage from './pages/TicketDetailPage';
import ProfilePage from './pages/ProfilePage';
import SearchPage from './pages/SearchPage';
import DashboardPage from './pages/DashboardPage';
import UsersPage from './pages/UsersPage';
import CategoriesPage from './pages/CategoriesPage';
import CustomersPage from './pages/CustomersPage';
import KanbanPage from './pages/KanbanPage';
import PublicSubmitPage from './pages/PublicSubmitPage';
import PortalLoginPage from './pages/portal/PortalLoginPage';
import PortalPage from './pages/portal/PortalPage';
import PortalTicketDetailPage from './pages/portal/PortalTicketDetailPage';

export default function App() {
  const { user, initialized, init } = useAuth();

  useEffect(() => {
    init();
  }, [init]);

  // Offentlig innsendingsside – ingen innlogging kreves
  if (window.location.pathname === '/submit') {
    return <PublicSubmitPage />;
  }

  // Kundeportal – helt separat fra staff-auth
  if (window.location.pathname.startsWith('/portal')) {
    return (
      <Routes>
        <Route path="/portal/login" element={<PortalLoginPage />} />
        <Route path="/portal/ticket/:id" element={<PortalTicketDetailPage />} />
        <Route path="/portal" element={<PortalPage />} />
        <Route path="/portal/*" element={<Navigate to="/portal" replace />} />
      </Routes>
    );
  }

  if (!initialized) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="animate-pulse text-slate-400">Laster…</div>
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/submit" element={<PublicSubmitPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Navigate to="/inbox" replace />} />
        <Route path="/inbox" element={<InboxPage />} />
        <Route path="/inbox/:id" element={<InboxPage />} />
        <Route path="/kanban" element={<KanbanPage />} />
        <Route path="/mine" element={<InboxPage filter="mine" />} />
        <Route path="/mine/:id" element={<InboxPage filter="mine" />} />
        <Route path="/ticket/:id" element={<TicketDetailPage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/users" element={<UsersPage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/submit" element={<PublicSubmitPage />} />
        <Route path="*" element={<Navigate to="/inbox" replace />} />
      </Route>
    </Routes>
  );
}
